import YouTubePlayer from 'youtube-player';
export default class YoutubeWrapper {
    initPlayer(options) {
        this.player = YouTubePlayer( options.videoNode, {
            videoId: options.videoId,
            playerVars: { rel : 0 }
        });

        this.player.on('ready', options.onReadyCallback);

        this.player.on('stateChange', (event) => {
            if ( event.data === YT.PlayerState.BUFFERING || event.data === YT.PlayerState.PLAYING ) {
                options.onPlayCallback();
            }
        });
    }

    play() {
        this.player.playVideo();
    }
    stop() {
        this.player.stopVideo();
    }
    getDuration() {
        // not needed for youtube
    }

}



// WEBPACK FOOTER //
// ./components/responsive-video/scripts/players/youtube-wrapper.js